/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Component to pick time
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { Fragment } from 'react';

import InputRange from 'react-input-range';

import { InputTimeContainerStyled, InputTimeLabelStyled } from './styled/UnlinkedCalendarStyled';

interface ITimePickerProps {
    onChangeHour: (hour: number) => void;
    onChangeMin: (min: number) => void;
    hour: number;
    min: number;
}

export const TimePicker = (props: ITimePickerProps) => (
        <Fragment>
            <InputTimeContainerStyled>
                <InputRange
                    formatLabel={(value) => `${value}.00`}
                    maxValue={23}
                    minValue={0}
                    step={1}
                    value={props.hour}
                    onChange={value => props.onChangeHour(value as number)}/>
            </InputTimeContainerStyled>
            <InputTimeLabelStyled>
                {('0' + props.hour).slice(-2)} : {('0' + props.min).slice(-2)}
            </InputTimeLabelStyled>
            <InputTimeContainerStyled>
                <InputRange
                    formatLabel={(value) => `${value}.00`}
                    maxValue={59}
                    minValue={0}
                    step={5}
                    value={props.min}
                    onChange={value => props.onChangeMin(value as number)}/>
            </InputTimeContainerStyled>
        </Fragment>
    )
